import { v1 } from 'uuid';

export default function uuid() {
  return v1();
}
